import types from './mutations-types';

const mutations = {
  [types.SET_LIST_WORD_CLOUD](state, payload) {
    state.listAnswersWordcloud = payload;
  },
  [types.SET_TRASH_ACTIONS](state, payload) {
    state.trash.actions = payload;
  },
  [types.SET_TRASH_ANSWERS](state, payload) {
    state.trash.answers = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/answers/mutations.js